import React, { createContext, useReducer, useEffect } from "react";

import transferReducer from "../reducer/transferReducer";

export const TransferContext = createContext();

export default function TransferContextProvider(props) {
  const [transfer, dispatch] = useReducer(transferReducer, {}, () => {
    const localData = localStorage.getItem("transfer");
    return localData ? JSON.parse(localData) : {};
  });

  const logout = () => {
    dispatch({
      type: "LOGOUT",
      payload: {},
    });
  };

  const addToTransfer = (data) => {
    dispatch({
      type: "ADD",
      payload: data,
    });
  };

  const removeTransfer = (data) => {
    dispatch({
      type: "REMOVE",
      payload: { receipt: data },
    });
  };

  useEffect(() => {
    localStorage.setItem("transfer", JSON.stringify(transfer));
  }, [addToTransfer]);

  return (
    <TransferContext.Provider
      value={{ transfer, addToTransfer, removeTransfer }}
    >
      {props.children}
    </TransferContext.Provider>
  );
}
